import { globalThisExisted, globalExisted, selfExisted } from './native.js';

var freeGlobalThis = globalThisExisted && globalThis.Object === Object && globalThis;
var freeGlobal = globalExisted && global.Object === Object && global;
var freeSelf = selfExisted && self.Object === Object && self;
var root = freeGlobalThis || freeGlobal || freeSelf || Function('return this')();

export { root as default };
